export default __webpack_public_path__ + "static/media/screenshot-01.3cfab720.jpg";